import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup, FormControl, AbstractControl  } from '@angular/forms';
import { RegisterService } from 'src/app/shared/services/firebase/register.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../shared/services/firebase/auth.service';
import { AngularFirestore } from '@angular/fire/firestore'
import { CustomValidator } from './custom.validato';
import { OappService } from 'src/app/shared/services/oapp.service';
import { CurBaseService } from 'src/app/shared/services/firebase/curbase.service';
import { ValidatorsService } from 'src/app/shared/services/validators.service';
import { first, map } from 'rxjs/operators';
import { NetsolinService } from '../../shared/services/netsolin.service'


// type UserFields = 'empresa' | 'name' | 'surname' | 'email' | 'psw' | 'profileImg' ;
type UserFields = 'empresa' | 'id' | 'name' | 'surname' | 'email' | 'psw'  ;
type FormErrors = { [u in UserFields]: string };

@Component({
  selector: 'app-register-with-image',
  templateUrl: './register-with-image.component.html',
  styleUrls: ['./register-with-image.component.scss']
})
export class RegisterWithImageComponent implements OnInit {
  usuarDetail: any;
  public usuarForm: FormGroup;
  public sidebaron: any;
  public formErrors: FormErrors = {
    'empresa': '',
    'id': '',
    'name': '',
    'surname': '',
    'email': '',
    'psw': '',
    // 'profileImg': ''
  };
  public errorMessage: any;
  public url: any;
  public avatraLink: any;
  public datosempre: any;
  public coincidenpsw=false;
  //Manejo de usuarios existentes
  //Para Netsolin se empieza a usar las propiedades como empresas
  private existeperfb = false;
  private existepernetsolin = false;
  private existempresafb = false;
  private existempresanetsolin = false;
  private usuarioNetsolin:any;
  private personafb:any;
  private userProfilefb:any;
  private adicionoEmpresaUsuar = false;
  private cargoEmpresa = false
  private estrucempresa = {
    code:"",
    id_reg:"",
    nit:"",
    nombre:"",
    parNetsolin:{prefijoemprenetsolin:"",urlservirestnetsolin:"", urlwebnetsolin:""},
    versionplat:"1",
    solonetsolin:true,

  };

  constructor(private fb: FormBuilder, private router: Router, private registerService: RegisterService,private toastr:ToastrService,
    private afs: AngularFirestore,
    public oapp: OappService,
    public authService: AuthService, public curBaseService:CurBaseService, private validatorsService:ValidatorsService, private netsolinService:NetsolinService) {
      console.log('constructor register oapp:',oapp);
    this.usuarForm = new FormGroup({
      empresa: new FormControl(),
      id: new FormControl(),
      name: new FormControl(),
      surname: new FormControl(),
      psw: new FormControl(),
      psw1: new FormControl(),
      email: new FormControl()
    });
}
  async ngOnInit() {
  // this.onChanges();
  // await this.oapp.getDatosAplica();

  this.usuarForm = this.fb.group({
    empresa:  ['',
      Validators.required,
      [this.validatorsService.existeEmpresa()]
    ],
    id:  ['',
    Validators.required
    //Se quita validacion por si el usuario esta en diferentes empresas solo se agrege la empresa deseada
    // [this.validatorsService.existeId()]
    ],
    name:  ['',
      Validators.required
    ],
    surname:  ['',
      Validators.required
    ],
    psw:  ['',
      Validators.required
    ],
    psw1:  ['',
    Validators.required
  ],
    email:  ['',
      Validators.required,
      [this.validatorsService.existeEmail()]
    ],

  });

  this.usuarForm.get("psw1").valueChanges.subscribe(val =>{
    console.log("cambio en psw1");
    if((this.usuarForm.get("psw").value == this.usuarForm.get("psw1").value) && (this.usuarForm.get("psw").value!='')){
      console.log("psws iguales");
      this.coincidenpsw = true;
    }else{
      this.coincidenpsw = false;
    }
  });

}
// Validators.email,

resetFields() {
  // this.usuarForm = this.fb.group({
  //   empresa: new FormControl('', Validators.required),
  //   name: new FormControl('', Validators.required),
  //   surname: new FormControl('', Validators.required),
  //   psw: new FormControl('', Validators.required),
  //   email: new FormControl('', Validators.required)
  // });
}
showSuccess(){
  this.toastr.success('Usuario Creado!');
}
  //Si cambia el nit empresa validar y buscar para registrar
  onChanges(): void {
    console.log('onChanges');
    this.usuarForm.get("empresa").valueChanges.subscribe(val => {
      console.log('onChanges empresa');
      var lcontrol: any;
      lcontrol = this.usuarForm.get("empresa");
      if (lcontrol.value) {
        console.log("set val lleno: "+lcontrol.value);
        this.validaempresa(lcontrol.value);
      } else {
        this.toastr.error('Debe incluir el nit de la empresa!');
        // lcontrol.setValue("0");
      }
    });
  }
  //valida si la empresa esta registrada
  validaempresa(valor) {
    if (valor) {
      this.toastr.success('Validar empresa !');
    } else {
      this.toastr.error('Debe incluir el nit de la empresa!');
    }
  }

  //Busca usuario si esta en netsolin para llenar campos
  blurId() {
    console.log('form id blurr');
    var estructurausr = { // Estructura para consulta de usuarios netsolin
      id: this.usuarForm.get("id").value,
      nit: this.usuarForm.get("empresa").value
    }
    console.log('estructurausr', estructurausr);
    this.netsolinService.consultarUsuarioNetsolin(estructurausr,this.cargoEmpresa, this.estrucempresa).then((res: any) => {
      console.log('res usuario netsolin', res);
      if (res.isCallbackError == undefined) {//Si recibe usuario de netsolin se llenan campos por defecto
        this.usuarForm.get("name").setValue(res[0].xgts2c2);
        this.usuarForm.get("surname").setValue(res[0].xgts2c2);
        this.usuarForm.get("email").setValue(res[0].email);
        this.usuarForm.get("psw").setValue(res[0].pd);
        this.usuarForm.get("psw1").setValue(res[0].pd);
        if(res[0].existe){
          this.existepernetsolin = true;
          this.usuarioNetsolin = res[0];
          this.existempresanetsolin = true;
        }
        //Busca usuario en firebase para ver si esta registrado y toca adicionar solo la empresa y el userprofile de esa empresa sin el proceso authentication de firebase
        this.curBaseService.consultaCollectionWhereFb('personas', 'id', this.usuarForm.get("id").value.toString(), '==').subscribe(res => {
          console.log('res usuario firebase', res);
          if (res.length > 0) {//Se encontro en fb
            this.existeperfb = true;
            this.personafb = res[0];
            this.usuarForm.get("email").setValue(this.personafb.email);
            //Deshabilita campos de registro porque ya esta en el sistema
            this.usuarForm.controls.email.disable();
            this.usuarForm.controls.psw.disable();
            this.usuarForm.controls.psw1.disable();
            //Busca userprofile para crearlo en otra empresa si es necesario
            this.curBaseService.consultaCollectionWhereFb( 'empresas/' + this.personafb.ultimaPropiedad +'/userProfile', 'id', this.usuarForm.get("id").value.toString(), '==').subscribe(res => {
              console.log('res userprofile firebase', res);
              this.userProfilefb = res[0];
            })
            this.validaEmpresasUsuario(res[0]);
          }if(res.length == 0){//No se encontro en fb
            this.creaEstructuraempresa();
            this.usuarForm.controls.email.enable();
            this.usuarForm.controls.psw.enable();
            this.usuarForm.controls.psw1.enable();
          }
        });
      }else{
        //El usuario no esta creado en netsolin
        //Se busca en firebase para llenar la informacion
        this.curBaseService.consultaCollectionWhereFb('personas', 'id', this.usuarForm.get("id").value.toString(), '==').subscribe(res => {
          console.log('res usuario firebase', res);
          if (res.length > 0) {//Se encontro en fb
            this.existeperfb = true;
            this.personafb = res[0];
            this.usuarForm.get("email").setValue(this.personafb.email);
            this.usuarForm.get("name").setValue(this.personafb.primerNombre);
            this.usuarForm.get("surname").setValue(this.personafb.primerApellido);
            this.usuarForm.get("psw").setValue('psw123456');
            this.usuarForm.get("psw1").setValue('psw123456');
            //Deshabilita campos de registro porque ya esta en el sistema de firebase
            this.usuarForm.controls.email.disable();
            this.usuarForm.controls.psw.disable();
            this.usuarForm.controls.psw1.disable();
            //Busca userprofile para crearlo en otra empresa si es necesario
            this.curBaseService.consultaCollectionWhereFb( 'empresas/' + this.personafb.ultimaPropiedad +'/userProfile', 'id', this.usuarForm.get("id").value.toString(), '==').subscribe(res => {
              console.log('res userprofile firebase', res);
              this.userProfilefb = res[0];
            })
            this.validaEmpresasUsuario(res[0]);
          }if(res.length == 0){//No se encontro en fb
            this.usuarForm.controls.email.enable();
            this.usuarForm.controls.psw.enable();
            this.usuarForm.controls.psw1.enable();
          }
        });
      }
    });
  }
 // Valida si el usuario ya existe y viene de otra empresa para crearla si no existe y adicionarla a la lista de empresas del usuario
  validaEmpresasUsuario(usuario){//Parametriza la estructura de la empresa por si es necesario crearla y la coloca donde se usa
    if(usuario.propiedades[this.usuarForm.get("empresa").value] == undefined){
      var empresa_init = this.oapp.netsolin_ini.nits_prefijosbd.find(item => item.nit == this.usuarForm.get("empresa").value);
      this.estrucempresa.code = this.usuarForm.get("empresa").value;
      this.estrucempresa.id_reg = this.usuarForm.get("empresa").value;
      this.estrucempresa.nit = this.usuarForm.get("empresa").value;
      this.estrucempresa.parNetsolin.prefijoemprenetsolin = empresa_init.prefijo;
      if(this.usuarioNetsolin != undefined){ //Evalua si el usuario viene de netsolin, de lo contrario llena de lo que encuentra en firebase
        this.estrucempresa.nombre = this.usuarioNetsolin.nomempre;
        this.estrucempresa.parNetsolin.prefijoemprenetsolin = this.usuarioNetsolin.prefijoemp;
      }
      this.estrucempresa.parNetsolin.urlservirestnetsolin = this.oapp.netsolin_ini.url_netsolins;
      this.estrucempresa.parNetsolin.urlwebnetsolin = this.oapp.netsolin_ini.urlwebnetsolin;
      console.log('Usuario no tiene esa empresa, se procede a adicionarla', this.estrucempresa);
      usuario.propiedades[this.usuarForm.get("empresa").value] = {};
      usuario.ultimaPropiedad = this.usuarForm.get("empresa").value;
      this.adicionoEmpresaUsuar = true;
      console.log('usuario modificado propiedades ->', usuario);
    }else{
      this.usuarForm.controls.id.setErrors({'incorrect': true, 'alreadyExists': true});
    }
  }

  //Crea Estructura de empresa si no existe en firebase y no existe usuario en firebase
  creaEstructuraempresa(){
    var empresa_init = this.oapp.netsolin_ini.nits_prefijosbd.find(item => item.nit == this.usuarForm.get("empresa").value);
    this.estrucempresa.code = this.usuarForm.get("empresa").value;
    this.estrucempresa.id_reg = this.usuarForm.get("empresa").value;
    this.estrucempresa.nit = this.usuarForm.get("empresa").value;
    this.estrucempresa.parNetsolin.prefijoemprenetsolin = empresa_init.prefijo;
    this.estrucempresa.nombre = this.usuarioNetsolin.nomempre;
    this.estrucempresa.parNetsolin.prefijoemprenetsolin = this.usuarioNetsolin.prefijoemp;
    this.estrucempresa.parNetsolin.urlservirestnetsolin = this.oapp.netsolin_ini.url_netsolins;
    this.estrucempresa.parNetsolin.urlwebnetsolin = this.oapp.netsolin_ini.urlwebnetsolin;
  }

  blurEmpresa(){
    if(this.usuarForm.get("empresa").valid){
      console.log('empresa valida');
      this.curBaseService.consultaCollectionWhereFb( 'empresas/', 'nit',this.usuarForm.get("empresa").value.toString(), '==').subscribe((res:any) => {
        console.log('res empresa firebase', res);
        if(res.length > 0){
          this.oapp.iniDatosEmpreFB(res[0]);
          this.estrucempresa = res[0];
          this.cargoEmpresa = true;
          this.existempresafb = true;
        }
      });

    }
  }


async submit(value) {
  console.log('a crear usuario',value);
  value.empresa = value.empresa.trim(); // hay nits con letra en las empresas y se corrige para que no lo pase a minuscula.
  value.id = value.id.toString();
  var empresa = await this.curBaseService.getCollectionIdWhereFB('empresas', 'code',value.empresa, '==')
  .pipe(first(),map(x=>x[0])).toPromise();
  console.log(empresa,'empresa')

  // this.registerService.createUserProfile(value,empresa);
  var estructurausr = {
    nit:value.empresa,
    id:value.id,
    nombre:value.name?value.name:"" + ' ' + value.surname?value.surname:"",
    email:value.email?value.email:"",
    psw:value.psw?value.psw:""
  }
  //Si empresa existe en netsolin pero no en fb se crea
  if(this.existempresanetsolin && !this.existempresafb){

    if(this.estrucempresa.id_reg.length>0){
      this.curBaseService.addDocConIdFb(value.empresa,'empresas',this.estrucempresa);
      empresa = await this.curBaseService.getCollectionIdWhereFB('empresas', 'code',value.empresa, '==')
      .pipe(first(),map(x=>x[0])).toPromise();
    }else{
      this.toastr.error('No encuentra estructura empresa para crear');
      return;
    }
  }
  this.netsolinService.registrarUsuarioNetsolin(estructurausr, this.cargoEmpresa, this.estrucempresa).then((res:any)=>{
    if(res.isCallbackError != undefined){
      this.toastr.error(res.messages[0].menerror);
    }else{
      if(this.existeperfb){ //Si existe en fb, y se va a registrar con otra empresa no se valida correo de auth porque ya existe
        //Se procede a actualizar los datos del usuario en la coleccion personas adicionandole la empresa seleccionada y crear el userprofile en esa empresa
        this.curBaseService.actDocFb(this.personafb.tipoID + this.personafb.id, '/personas', { ultimaPropiedad:this.personafb.ultimaPropiedad, propiedades:this.personafb.propiedades });
        this.userProfilefb.empresa = this.estrucempresa; //Coloca los parametros de la empresa que se usaran para este userprofile en otra empresa
        this.registerService.createUserExiste(this.personafb, this.userProfilefb, empresa)
        .then(
          res => {
            console.log('res crear usuaio',res);
            console.log('res crear usuario netsolin',res);
            this.resetFields();
            this.router.navigate(['/auth/login']);
            this.showSuccess()
          }
        )
      }else{
        value.email = value.email.toLowerCase().trim();
        this.authService.registerUser(value.email,value.psw).then(async user=>{
          this.registerService.createUser(value, this.url, empresa)
            .then(
              res => {
                console.log('res crear usuaio',res);
                console.log('res crear usuario netsolin',res);
                this.resetFields();
                this.router.navigate(['/auth/login']);
                this.showSuccess()
              }
            )
        }).catch(async error =>{
          console.log(error);
          if (error.message ==='The email address is already in use by another account.'){
            this.toastr.error('El email ya esta siendo usado por otra cuenta!');
            console.error('Email...',error);
          } else {
            this.toastr.error(error.message );
            console.error(error);
        }
        });
      }
    }
  });
}

//FileUpload
readUrl(event: any) {
  if (event.target.files.length === 0)
    return;
  //Image upload validation
  var mimeType = event.target.files[0].type;
  if (mimeType.match(/image\/*/) == null) {
    return;
  }
  // Image upload
  var reader = new FileReader();
  reader.readAsDataURL(event.target.files[0]);
  reader.onload = (_event) => {
    this.url = reader.result;
  }
}

cambio2psw(a){
  console.log("Cambio en campo psw 2", a);


}


cancel() {
  this.router.navigate(['/auth/login']);
}


}
